export var LOWEST_PREVIOUS_PRICE = 'LowestPreviousPrice';
//# sourceMappingURL=lowestPreviousPrice.js.map